import { useEffect, useRef } from 'react';
import { useSocket } from '../../context/SocketContext';
import { useAuthStore } from '../../stores/useAuthStore';
import { useChatStore } from '../../stores/useChatStore';
import { useInteractionStore } from '../../stores/useInteractionStore';
import { useDataStore } from '../../stores/useDataStore';
import { useAdminStore } from '../../stores/adminStore'; // 🟢 Importamos el store de admin
import toast from 'react-hot-toast';
import notificationSoundFile from '/src/assets/sounds/notification.mp3'; // 🟢 CORRECCIÓN: Ruta de importación corregida

/**
 * Este componente no renderiza nada. Su único propósito es
 * centralizar los listeners de eventos globales de Socket.IO.
 */
const GlobalListeners = () => {
  const { socket, onlineUsers } = useSocket();
  const currentUser = useAuthStore((state) => state.currentUser);
  const isLoggedIn = useAuthStore((state) => state.isLoggedIn);
  const isVerifying = useAuthStore((state) => state.isVerifying);
  const token = useAuthStore((state) => state.token);
  const setAuthUser = useDataStore((state) => state.setAuthUser);
  const fetchFriendsData = useInteractionStore((state) => state.fetchFriendsData);
  const fetchNotifications = useInteractionStore((state) => state.fetchNotifications);
  const fetchFeed = useDataStore((state) => state.fetchFeed);
  
  // Orquestador de Carga de Datos
  useEffect(() => {
    const authToken = token || localStorage.getItem('token');
    if (currentUser && isLoggedIn && !isVerifying && authToken) {
      setAuthUser?.(currentUser);
      fetchFriendsData?.();
      fetchNotifications?.();
      fetchFeed?.();
    }
  }, [currentUser?._id, isLoggedIn, isVerifying, token, setAuthUser, fetchFriendsData, fetchNotifications, fetchFeed]);

  const originalTitle = useRef(document.title);
  const notificationSound = useRef(new Audio(notificationSoundFile));

  // Actualiza el estado online de los amigos
  useEffect(() => {
    if (onlineUsers) {
      useInteractionStore.getState().updateOnlineUsers(onlineUsers);
    }
  }, [onlineUsers]);

  // Listeners de Socket.IO
  useEffect(() => {
    if (!socket || !currentUser) return;

    const handleWalletUpdate = ({ newBalance }) => {
      useAuthStore.getState().setCurrentUser({ ...currentUser, coins: newBalance });
      toast.success('¡Tu compra se ha completado con éxito!');
    };

    // 🔴 CRÍTICO: new-message es manejado por useChat.js hook con validación completa
    // Aquí solo caemos a addMessage(message) sin conversationId, causando undefined _id
    // Typing también manejado por useChat.js

    const handleNewNotification = (notification) => useInteractionStore.getState().addNotification(notification);

    const handleNewSupportTicket = (ticket) => {
      useAdminStore.getState().setHasNewTicket(true);
      toast.success(`Nuevo ticket de soporte de ${ticket.user?.username || 'un usuario'}.`);
      notificationSound.current.play().catch(console.error);
    };

    socket.on('wallet-updated', handleWalletUpdate);
    // 🔴 new-message y typing: REMOVIDOS, manejados por useChat.js
    socket.on('new-notification', handleNewNotification);
    socket.on('new-support-ticket', handleNewSupportTicket);

    return () => {
      socket.off('wallet-updated');
      // 🔴 new-message y typing removidos
      socket.off('new-notification');
      socket.off('new-support-ticket');
    };
  }, [socket, currentUser?._id]); // ✅ FIX: Solo ID, no objetos ni funciones

  // Actualiza el título de la página con el contador de no leídos
  useEffect(() => {
    const unsubscribe = useChatStore.subscribe((state) => state.unreadCounts, (unreadCounts) => {
      const count = Object.values(unreadCounts).reduce((sum, count) => sum + count, 0);
      document.title = count > 0 ? `(${count}) ${originalTitle.current}` : originalTitle.current;
    });
    return unsubscribe;
  }, []);

  return null;
};

export default GlobalListeners;
